import { render, staticRenderFns } from "./InsuranceCompany.vue?vue&type=template&id=02af87e6"
import script from "./InsuranceCompany.vue?vue&type=script&lang=js"
export * from "./InsuranceCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports